import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import "antd/dist/antd.css";
import Router from "./router";
import i18n from "./translation";
// analytics
// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const App = () => (
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <Router />
    </I18nextProvider>
  </BrowserRouter>
);

// ReactDOM.render(<App />, document.getElementById("root"));

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <App />
);


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBRpk0K4Xm2OWFdIAVDlzR_kcMyYP1uFe0",
//   authDomain: "pixel-king-gaming.firebaseapp.com",
//   projectId: "pixel-king-gaming",
//   storageBucket: "pixel-king-gaming.firebasestorage.app",
//   messagingSenderId: "1084104513964",
//   appId: "1:1084104513964:web:472b783736ca2d6fa34209",
//   measurementId: "G-F86KXN88FJ"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);